import React from 'react';
import AboutSection from '../components/AboutSection';
import ServicesGrid from '../components/ServicesGrid';
import '../styles/About.css';

const About = () => {
    return (
        <div id="about" className="about-section">
            <AboutSection />
            <div className="services-section">
                <h2 className="section-title">Our Services</h2>
                <div className="services-carousel-container">
                    <div className="services-carousel-wrapper">
                        <ServicesGrid />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
